import React, { forwardRef, useState } from "react";
import classNames from "classnames";
import Item from "./Item";
import List from "./List";

export const NavigationLine = ({ className }) => {
  return <hr className={classNames("navigation-line", className)} />;
};

export const NavigationTitle = ({ className, children, ...props }) => {
  return (
    <li className="navigation-item">
      <span className={classNames("navigation-title", className)} {...props}>
        {children}
      </span>
    </li>
  );
};

const Navigation = forwardRef(
  ({ menu, horizontal, id, className, ...props }, ref) => {
    const [activeItem, setActiveItem] = useState(undefined);

    function fillMenu(data, parentId, rootId, isHorizontal, isMore) {
      return Object.keys(data).map((item) =>
        data[item].path ? (
          <Item
            key={data[item].id}
            rootId={rootId}
            id={data[item].id}
            title={data[item].text}
            icon={data[item].iconName}
            to={`${data[item].path}`}
            parentId={parentId}
            isHorizontal={isHorizontal}
            setActiveItem={setActiveItem}
            activeItem={activeItem}
            notification={data[item].notification}
            hide={data[item].hide}
          >
            {!!data[item].subMenu &&
              fillMenu(
                data[item].subMenu,
                data[item].id,
                rootId,
                isHorizontal,
                undefined
              )}
          </Item>
        ) : (
          !isMore &&
          !isHorizontal && (
            <NavigationTitle key={data[item].id}>
              {data[item].text}
            </NavigationTitle>
          )
        )
      );
    }

    return (
      <nav ref={ref} aria-label={id} className={className} {...props}>
        <List id={id} horizontal={horizontal}>
          {fillMenu(menu, id, id, horizontal, undefined)}
          {horizontal && (
            <Item
              rootId={`other-${id}`}
              title={"More"}
              icon="MoreHoriz"
              isHorizontal
              isMore
            >
              {fillMenu(menu, `other-${id}`, `other-${id}`, false, true)}
            </Item>
          )}
        </List>
      </nav>
    );
  }
);

export default Navigation;
